import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom"
import InstallProgress from "../appexchange/install-porgress";
import UpgradePackage from "../appexchange/UpgradePackage";
import {
    retrievePkceVerifier,
    retrieveStateNonce,
    clearPkceSession,
} from '../../utils/pkce';

const SalesforceAuth = () => {
    const [loader, setLoader] = useState(true);
    const [showInstallProgress, setShowInstallProgress] = useState(false);
    const [showUpgradeProgress, setShowUpgradeProgress] = useState(false);
    const [installProgressState, setInstallProgressState] = useState({});
    const [upgradeProgressState, setUpgradeProgressState] = useState({});
    const [pkceError, setPkceError] = useState('');
    // Prevents double-execution of the PKCE validation in React StrictMode dev.
    const pkceProcessedRef = useRef(false);

    useEffect(() => {
        getState();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    // const setCookie = (access_token, refresh_token) => {
    //     document.cookie = "mAgIC_pAnDa=" + access_token + ";path=/";
    //     document.cookie = "mAgIC_r_pAnDa=" + refresh_token + ";path=/";
    //     console.log("cookies ", document.cookie);
    // };

    var signupUrl = process.env.REACT_APP_SOCIAL_API;
    console.log("signupUrl: ", signupUrl)
    const navigate = useNavigate();

    let callbackUrl = window.location.href;
    console.log("callback URL --> ", callbackUrl)

    let queryStr = callbackUrl.split("?")
    console.log("querytrsing --> ", queryStr)
    
    signupUrl = `${signupUrl}?${queryStr[1]}`;
    let data=queryStr[1];

    let params = new URLSearchParams(data);
    let state = params.get('state');
    let code=params.get('code');
    let source = null;
    let dataCenter = null;
    let action = null;
    let org_type=null;
    let skip_data_center_check=null;
    // nonce embedded by install-package.js for PKCE state validation
    let nonce_from_state = null;

    let addons={}

    if (state) {
        let stateParams = new URLSearchParams(decodeURIComponent(state));
        source = stateParams.get('source');
        dataCenter = stateParams.get('dataCenter');
        action = stateParams.get('action');
        org_type=stateParams.get('org_type');
        skip_data_center_check=stateParams.get('skip_data_center_check')=== 'true';
        nonce_from_state = stateParams.get('nonce');
        if(skip_data_center_check==true){    // eslint-disable-line eqeqeq
            console.log('skip_data_center_check',skip_data_center_check);
            if(action=="install"){   // eslint-disable-line eqeqeq
                addons={
                    type:"install",
                    package_installed:stateParams.get('package_installed') === 'true',
                    account_exists:stateParams.get('account_exists') === 'true'
                }
            }else if(action=="upgrade"){   // eslint-disable-line eqeqeq
                addons={
                    type:"upgrade",
                    package_installed:stateParams.get('package_installed') === 'true',
                    account_exists:stateParams.get('account_exists') === 'true',
                    latest_version:stateParams.get('latest_version'),
                    upgrade_available:stateParams.get('upgrade_available')=== 'true',
                    package_version:stateParams.get('package_version'),
                }
            }

        }    
        console.log('addons',addons);
    }

    let getState = async (e) => {
        if (state && source === 'app_exchange') {
            // skip_data_center_check=true means this is a synthetic cross-datacenter
            // redirect constructed by InstallProgress/UpgradePackage — not a fresh
            // Salesforce auth response. The code_verifier was already embedded in
            // queryStr[1] by the component that built this redirect URL, so no
            // cookie validation is needed here.
            if (!skip_data_center_check) {
                // Guard against React StrictMode double-invocation in dev: only
                // validate PKCE on the first execution of this effect.
                if (pkceProcessedRef.current) {
                    return;
                }
                pkceProcessedRef.current = true;

                const storedVerifier = retrievePkceVerifier();
                const storedNonce = retrieveStateNonce();

                if (!storedVerifier) {
                    // Cookie not found — either expired (Max-Age=300), cleared by
                    // the browser, or the login was abandoned. Do not attempt token exchange.
                    clearPkceSession();
                    setLoader(false);
                    setPkceError('Your login session has expired. Please return to the installation page and try again.');
                    return;
                }

                if (!storedNonce || storedNonce !== nonce_from_state) {
                    // State mismatch — possible CSRF or stale session. Abort.
                    clearPkceSession();
                    setLoader(false);
                    setPkceError('Login session is invalid. Please return to the installation page and try again.');
                    return;
                }

                // Embed the verifier in queryStr so InstallProgress / UpgradePackage
                // include it when they call the backend API. The backend must forward
                // code_verifier to Salesforce in its token exchange POST.
                const enrichedQueryStr = `${queryStr[1]}&code_verifier=${encodeURIComponent(storedVerifier)}`;

                // Clear PKCE cookies immediately — the verifier now lives in
                // enrichedQueryStr and is forwarded to the backend from there.
                clearPkceSession();

                setInstallProgressState({ queryStr: enrichedQueryStr, dataCenter, action, org_type, skip_data_center_check, code, addons });
                setUpgradeProgressState({ queryStr: enrichedQueryStr, dataCenter, action, org_type, skip_data_center_check, code, addons });
            } else {
                // Cross-datacenter synthetic redirect: pass queryStr through as-is.
                // The verifier was embedded by the component that built this URL.
                setInstallProgressState({ queryStr: queryStr[1], dataCenter, action, org_type, skip_data_center_check, code, addons });
                setUpgradeProgressState({ queryStr: queryStr[1], dataCenter, action, org_type, skip_data_center_check, code, addons });
            }

            if (action === 'upgrade') {
                setShowUpgradeProgress(true);
            } else {
                setShowInstallProgress(true);
            }
            setLoader(false);
            return;
        }

        if (state && decodeURIComponent(state).includes('is_slg=True')) {
            let slgUrl=process.env.REACT_APP_SF_SLG_API;
            slgUrl= `${slgUrl}?${queryStr[1]}`;
            let res = await fetch(slgUrl, {
                method: "GET",
            });
            let resJson = await res.json();
            if (res.status === 200) {
                console.log("api response::sf ", resJson, resJson.access_token);
                localStorage.setItem("stories_delight", resJson.access_token);
                localStorage.setItem("hideBullhorn", "false");
                window.location.replace(`${process.env.REACT_APP_LANDING_PAGE_BASE_URL}workspace`);
            }
            else if (res.status === 400) {
                alert(resJson.message)
                window.location.replace(process.env.REACT_APP_SIGNUP_PAGE_URL);
            }
            else {
                alert("SOMETHING WENT WRONG")
                window.location.replace(process.env.REACT_APP_SIGNUP_PAGE_URL);
            }

        }else{
        console.log("singup url --> ", signupUrl)
        let res = await fetch(signupUrl, {
            method: "GET",
        });
        console.log("api response: ", res)
        let resJson = await res.json();
        if (res.status === 200) {
            console.log("api response::sf ", resJson, resJson.access_token);
            localStorage.setItem("stories_delight", resJson.access_token);
            // setCookie(resJson.access_token, resJson.refresh_token);
            localStorage.setItem("hideBullhorn", "false");
            window.location.replace(`${process.env.REACT_APP_LANDING_PAGE_BASE_URL}workspace`);
        }
         else if (res.status === 409) {
            console.log("#form state: ", resJson)
            let query_params = {}
            resJson["status_code"] = 409;
            if (resJson.plan_name) {query_params.plan = resJson.plan_name}
            if (resJson.utm_campaign) {query_params.utm_campaign = resJson.utm_campaign}
            if (resJson.utm_medium) {query_params.utm_medium = resJson.utm_medium}
            if (resJson.utm_source) {query_params.utm_source = resJson.utm_source}
            let query_str = new URLSearchParams(query_params).toString()
            console.log("query_str: ", queryStr)
            navigate(`/?${query_str}`, {state: resJson})
        }
        else if (res.status === 403) {
            console.log("#form state: ", resJson)
            let query_params = {}
            resJson["status_code"] = 403;
            if (resJson.plan_name) {query_params.plan = resJson.plan_name}
            if (resJson.utm_campaign) {query_params.utm_campaign = resJson.utm_campaign}
            if (resJson.utm_medium) {query_params.utm_medium = resJson.utm_medium}
            if (resJson.utm_source) {query_params.utm_source = resJson.utm_source}
            let query_str = new URLSearchParams(query_params).toString()
            console.log("query_str: ", queryStr)
            navigate(`/?${query_str}`, {state: resJson})
        }
        else if (res.status === 400) {
            alert(resJson.message)
            window.location.replace(process.env.REACT_APP_SIGNUP_PAGE_URL);
        } else {
            alert("SOMETHING WENT WRONG")
            window.location.replace(process.env.REACT_APP_SIGNUP_PAGE_URL);
        }
    }
    }

    return (
        showInstallProgress ? (
            <InstallProgress state={installProgressState} />
        ) : showUpgradeProgress ? (
            <UpgradePackage state={upgradeProgressState} />
        ) : (
            <div>
                {loader ? (
                    <div className="centered-spinner">
                        <div className="spinner-border" role="status" />
                    </div>
                ) : null}
                {pkceError ? (
                    <div className="centered-spinner">
                        <p style={{ color: '#d93025', textAlign: 'center', padding: '20px' }}>
                            {pkceError}
                        </p>
                    </div>
                ) : null}
            </div>
        )
    );

}

export default SalesforceAuth;
